import { ChevronRightIcon } from '~/components/icons'
import { useEffect, useRef, useState } from 'react'
import { createOptimizedContentfulImageStr } from '~/libs/contentful/helpers'
import { FlexContainer } from '~/components/Grid'
import { AssetData } from './Instruments'

export const Card = ({ item }: { item: AssetData }) => {
  let intervalRewind: NodeJS.Timeout | undefined = undefined

  const videoEl = useRef<HTMLVideoElement>(null)
  const [windowWidth, setWindowWidth] = useState<number | null>(null)

  useEffect(() => {
    setWindowWidth(window.innerWidth)
  }, [])

  const videoPlay = () => {
    clearInterval(intervalRewind)
    videoEl.current?.play()
  }

  const videoReverse = () => {
    videoEl.current?.pause()
    intervalRewind = setInterval(function () {
      if (videoEl.current?.currentTime) {
        videoEl.current.currentTime -= 0.025
      }
      if (videoEl.current?.currentTime == 0) {
        clearInterval(intervalRewind)
      }
    }, 25)
  }
  const videoBlock = () => {
    if (windowWidth && windowWidth <= 1023) return
    return (
      <video
        className="object-contain h-full text-center absolute left-1/2 top-0 overflow-hidden text-2xl"
        src={item.video}
        muted
        playsInline
        ref={videoEl}
        style={{
          width: '101%',
          borderRadius: '20px',
          marginBottom: '10px',
          transform: 'translateX(-50%)',
        }}
      />
    )
  }

  return (
    <a
      href={item.link}
      onMouseEnter={videoPlay}
      onMouseLeave={videoReverse}
      className="text-2xl my-0 mx-auto instruments-card"
    >
      <div className="card-media text-2xl max-md:h-[337px] h-[238px] max-xl:h-[300px] max-xl:[&_video]:hidden relative rounded-[20px] w-full overflow-hidden mb-6 text-center bg-neutral-10">
        <img
          className={
            'w-full overflow-hidden object-contain object-center h-full mb-3 text-center card-image text-2xl'
          }
          style={{ borderRadius: '20px', transition: 'transform .4s ease' }}
          src={createOptimizedContentfulImageStr(item.image.url, {
            quality: 80,
            width: 350,
          })}
          alt={item.image.alt}
          loading="lazy"
        />
        {item.video && videoBlock()}
      </div>
      <FlexContainer justify={'between'} flexWrap={'nowrap'} style={{ padding: '0 10px' }}>
        <div
          className="[&>span]:text-blue-50 max-w-[350px] text-desktop-s"
          dangerouslySetInnerHTML={{ __html: item.title }}
        ></div>
        <div
          className={
            'card-list__link max-lg:hidden [&_.swiper-button-disabled]:pointer-events-none  active:bg-neutral-20 hover:bg-neutral-10 focus-visible:bg-neutral-10 cursor-pointer outline-none flex items-center justify-center flex-shrink-0 p-0 ml-4 w-8 h-8 border-none rounded-[100%] bg-neutral-5 text-neutral-50'
          }
          style={{ transition: 'color 0.15s, background-color 0.15s' }}
        >
          <ChevronRightIcon width="14px" height="14px" />
        </div>
      </FlexContainer>
    </a>
  )
}
